// Keys ougt to be sorted alphabetically, case sensitive.	Pools
// To autosort: repeat CTRL+S until all keys are sorted
//  OR
// repeat command until sorted: npm run lint-fix

/* eslint sort-keys-fix/sort-keys-fix: error */
export default {
  accesslog: {
    accessedAt: 'Datum tijd',
    accessedBy: 'Geopend door',
    accessedResource: 'Gebruikte bron',
    ip: 'IP',
    parameters: 'Parameters'
  },
  ban: {
    bannedAtUtc: 'Verbannen op (UTC)',
    bannedUntilUtc: 'Verbannen tot (UTC)'
  },
  common: {
    active: 'Actief',
    add: 'Toevoegen',
    address: 'Adres',
    addressee: 'Geadresseerde',
    bankAccountBIC: 'BIC',
    bankName: 'Bank',
    barcodePrefix: 'Barcode voorloopnummer',
    barcodeType: 'Type barcode',
    bdo: 'BDO',
    billingAddress: 'Factuuradres',
    billingEmail: 'Factuur E-mailadres',
    block_notification_not_saved_warning: 'Notificatie instelling niet opgeslagen. Probeer het later opnieuw',
    browserNotSupported: 'Uw browser ondersteunt deze functionaliteit niet',
    businessRegisterNumber: 'KvK-nummer',
    cancel: 'Annuleren',
    city: 'Plaats',
    clearFilters: 'Verwijder alle filters',
    close: 'Sluiten',
    close_unsaved_warning: 'Uw wijzigingen zijn nog niet opgeslagen. Weet u zeker dat u dit scherm wilt sluiten?',
    code: 'Code',
    company: 'Bedrijf',
    companyAddress: 'Bezoekadres',
    companyEmail: 'E-mailadres',
    confirm: 'Bevestigen',
    continue: 'Doorgaan',
    copyToClipboard: 'Kopiëer naar klembord',
    copyToClipboardFail: 'Kopiëren naar klembord mislukt',
    copyToClipboardSuccess: 'Kopiëren naar klembord gelukt',
    country: 'Land',
    createReport: 'Maak overzicht',
    creditorNumber: 'Creditor number',
    currency: 'Valuta',
    data_created: 'De gegevens zijn opgeslagen',
    data_save_error: 'De gegevens kunnen niet worden opgeslagen',
    data_updated: 'De wijzigingen zijn opgeslagen',
    date: 'Datum',
    debtorNumber: 'Debiteurennummer',
    decimals: 'Decimalen',
    defaultBottomFinishID: 'Standaard onderzoom',
    defaultBottomFinishMeasurementInCm: 'Standaardmaat onderzoom (cm)',
    defaultEmbraceFinishID: 'Standaard embrasse',
    defaultSideFinishID: 'Standaard zijzoom',
    defaultSideFinishMeasurementInCm: 'Standaardmaat zijzoom (cm)',
    defaultTopFinishID: 'Standaard bovenafwerking',
    defaultTopFinishMeasurementInCm: 'Standaardmaat bovenafwerking (cm)',
    delete: 'Verwijder',
    deletePlural: 'Verwijderen',
    delete_cancelled: 'Verwijderen geannuleerd',
    delete_completed: 'De gegevens zijn verwijderd',
    delete_record_summary_warning: 'Weet u zeker dat u <b>{summary}</b> wilt verwijderen?',
    delete_record_warning: 'Weet u zeker dat u dit wilt verwijderen?',
    department: 'Afdeling',
    description: 'Beschrijving',
    domain: 'Domein',
    domains: 'Domeinen',
    dontSave: 'Niet opslaan',
    dontSend: 'Niet verzenden',
    dont_show_again_warning: 'Niet meer tonen',
    downloadExcel: 'Download Excel',
    downloadPDF: 'Download PDF',
    draft: 'Concept',
    ean: 'EAN-13',
    edit: 'Bewerk',
    email: 'E-mailadres',
    emptyString: ' ',
    endDate: 'Einddatum',
    error: 'Fout',
    exactInstance: 'Exact',
    excludedFinishes: 'Niet mogelijke afwerkingen',
    export: 'Export',
    fabricProduct: 'Stofsoort',
    fabricType: 'Stofsoort',
    fabricWidth: 'Stofbreedte',
    fax: 'Fax',
    fillInANumber: 'Vul een getal in',
    finish: 'Afwerking',
    finishType: 'Afwerkingssoort',
    finishes: 'Afwerkingen',
    firstName: 'Voornaam',
    fixedPhone: 'Vaste telefoon',
    from: 'van',
    gender: 'Geslacht',
    glAccountNumber: 'Grootboeknummer',
    glAccountNumbers: 'Grootboeknummers',
    iban: 'IBAN',
    id: 'ID',
    inactive: 'Inactief',
    initials: 'Initialen',
    invoiceAddress: 'Factuuradres',
    ipAddress: 'IP-adres',
    jobFunction: 'Functie',
    key: 'Key',
    lastName: 'Achternaam',
    leave_mail_warning: 'U verlaat deze pagina. Wilt u eerst deze mail verzenden?',
    leave_unsaved_warning: 'U verlaat deze pagina. Wilt u de wijzigingen opslaan?',
    loading: 'Laden ...',
    mailingAddress: 'Postadres',
    measurement: 'Afmeting',
    meter: 'meter',
    mobilePhone: 'Mobiele telefoon',
    name: 'Naam',
    no: 'Nee',
    notApplicable: 'Niet van toepassing',
    notApplicableAbbr: 'n.v.t.',
    number: 'Numer',
    off: 'off',
    ok: 'OK',
    on: 'on',
    order: 'Order',
    orders: 'Orders',
    otherPrintClients: 'Overig',
    password: 'Wachtwoord',
    phone: 'Telefoon',
    plannedWorkshopPrintClient: 'Atelier als gepland',
    postalCode: 'Postcode',
    prefix: 'Tussenvoegsel',
    price: 'Prijs',
    printers: 'Printers',
    priority: 'Prioriteit',
    productGroup: 'Productgroep',
    productType: 'Artikelsoort',
    publish: 'Publiceren',
    readMore: 'Lees meer ...',
    remark: 'Opmerking',
    remarks: 'Opmerkingen',
    required: 'Verplicht',
    save: 'Opslaan',
    saveClose: 'Opslaan & sluiten',
    saveNext: 'Opslaan & volgende',
    search: 'Zoek',
    selectPrinter: 'Selecteer bestemming voor printen',
    selectPrinterConfirm: 'Selecteer',
    send: 'Verzenden',
    series: 'Seria',
    service: 'Service',
    shipmentList: 'Shipment list',
    standard: 'Standaard',
    startDate: 'Begindatum',
    status: 'Status',
    stay: 'Blijf op pagina',
    stockLocations: 'Voorraadlocaties',
    stockUnit: 'Verpakkingseenheid',
    store: 'Vestiging',
    streetName: 'Straat',
    streetNumber: 'Huisnummer',
    success: 'Succes',
    supplier: 'Leverancier',
    switchOff: 'Uit',
    switchOn: 'Aan',
    tabDetails: 'Details',
    tabGeneral: 'Algemeen',
    taskstatus: 'Taakstatus',
    till: 'tot',
    title: 'Titel',
    to: 'Naar',
    total: 'Totaal',
    transport: 'Transport',
    type: 'Type',
    unit: 'Eenheid',
    username: 'Gebruikersnaam',
    value: 'Value',
    vatNumber: 'BTW-nummer',
    warning: 'Waarschuwing',
    week: 'Week',
    weeks: 'Weken',
    workshop: 'Atelier',
    workshopPrintClients: 'Ateliers',
    workshops: 'Workshops',
    yarn: 'Garen',
    year: 'Jaar',
    yes: 'Ja'
  },
  company: {
    administrationNumber: 'Administratienummer',
    clientSalesJournalCode: 'Verkoopdagboek klantfactuur',
    exact: 'Exact',
    exactServerName: 'Servernaam',
    fiscalUnit: 'Fiscale eenheid',
    intercompanySalesJournalCode: 'Verkoopdagboek intercompany factuur',
    intrastatReporting: 'Intrastat reporting',
    logo: 'Logo',
    purchaseJournalCode: 'Inkoopdagboek nummer',
    purchaseJournalType: 'Inkoopdagboek type',
    remarkInvoice: 'Opmerking factuur',
    salesJournalType: 'Verkoopdagboek type'
  },
  componentList: {
    amountReturn: 'Zwrot',
    extras: 'Dodatki',
    lined: 'Z podszewką',
    metersAmount: 'Liczba metrów',
    panelsAmount: 'Liczba bryt',
    piecesAmount: 'Ilość',
    product: 'produktu',
    productType: 'typ produktu',
    romanBlindsAmount: 'Liczba rolet rzymskich',
    total: 'Całkowity',
    totals: 'Sumy',
    unlined: 'Bez podszewki',
    weeks: 'Tygodni'
  },
  configuration: {
    code: 'Kod',
    fromDate: 'Ważne od',
    value: 'Wartość'
  },
  country: {
    eu: 'Europese Unie'
  },
  currency: {
    isoCode: 'ISO code',
    symbol: 'Symbool'
  },
  domain: {
    all: 'Moje domeny',
    apiKey: 'Klucz API',
    barcodePrefix: 'Kod kreskowy',
    chooseDomain: 'Wybierz domenę',
    company: 'Bedrijf',
    createFabrics: 'Stoffen aanmaken',
    culture: 'Culture',
    cultures: 'Cultures',
    deliveryPrice: 'Bezorgprijs',
    deliveryPrices: 'Bezorgprijzen',
    distributionCenter: 'Distributiecentrum',
    domainCode: 'Code domein',
    domainDescription: 'Omschrijving domein',
    export: 'Facturen exporteren via',
    familyOrderPacking: 'Family order packing',
    invalidFinishCombinations: 'Niet-toegestane afwerkingscombinaties',
    invoiceName: 'Naam op factuur',
    invoicePer: 'Factureren per',
    lastStockWorkshop: 'Ontvangend atelier uitlopende voorraad',
    nameOnTicket: 'Naam op bon',
    noData: 'Geen domeinen bekend',
    orderNumberPrefix: 'Ordernummer prefix',
    paymentDiscountPercentage: 'Betalingskorting (%)',
    paymentTermDays: 'Betalingstermijn (dagen)',
    priceDescription: 'Gekoppelde prijs',
    productGroup: 'Instellingen productgroep',
    productGroupFinishApplicable: 'Beschikbaar voor dit domein',
    productGroupFinishes: 'Domeinspecifieke afwerkingen',
    productGroupPrices: 'Prijzen',
    productGroupSettings: '{domainName} - Instellingen voor productgroep {productGroup}',
    rfidEnabledYN: 'RFID',
    rfidPrefix: 'RFID prefix',
    showOrdersInvoicePer: 'Showbanen factureren per',
    storeAttributes: 'Kenmerken vestiging',
    storeTypes: 'Vestigingstypes',
    stores: 'Vestigingen',
    stripCorrection: 'Stripcorrectie (banen)',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabProducts: 'Artikelen',
    tabSettings: 'Instellingen',
    transportOrderMultipleWorkshops: 'Meerdere ateliers op verzendlijst'
  },
  error: {
    general_request: 'Er is iets fout gegaan. Probeer het later opnieuw.',
    oneOrMoreInputs: 'De gegevens kunnen niet worden opgeslagen want het formulier bevat fouten.',
    save: 'Er is iets fout gegaan. Probeer het later opnieuw.'
  },
  errorLog: {
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction',
    tips: 'Please click the bug icon in the upper right corner'
  },
  errorPages: {
    backToHome: 'Powrót na stronę główną',
    headline401: 'Nie masz dostępu do tej strony',
    headline403: 'Nie masz dostępu do tej strony',
    headline404: 'Strona nie znaleziona',
    message401: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message403: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message404: 'Controleer of de ingevoerde URL correct is.',
    return: 'Terug',
    title401: 'Oops',
    title403: 'Toegang geweigerd',
    title404: 'Sorry'
  },
  eventlog: {
    exception: 'Exception',
    level: 'Level',
    logger: 'Logger',
    message: 'Message',
    occurredAt: 'Datum tijd',
    thread: 'Thread'
  },
  exactInstance: {
    serverName: 'Server name',
    serviceUrl: 'Service URL'
  },
  fabric: {
    actualWidth: 'Szerokość rzeczywista (cm)',
    availableStock: 'Dostępne zapasy',
    blackout: 'Blackout',
    canBeLined: 'Możliwa podszewka',
    canBeUsedAsLiningForRomanBlindsYN: 'Nadaje się do podszewki do rolet rzymskich',
    canBeUsedAsLiningYN: 'Można stosować jako podszewkę',
    canBeUsedForRomanBlinds: 'Można stosować na roletę',
    collections: 'Kurz książki',
    consumerPrices: 'Ceny konsumenta',
    containsWeightCord: 'Z ołowianką',
    cordProduct: 'Sznurek',
    createdAt: 'Wykonane na',
    cuttingWastePercentage: 'Odpad (%)',
    description: 'Opis',
    discontinuationDate: 'Po terminie',
    domainProductCode: 'Numer artykułu',
    excludedWorkshops: 'Wyłączone atelier',
    fabricStatusOption: 'Status',
    flawInWeavingPercentage: 'Wada w dziale tkackim (%)',
    handlock: 'Handlock',
    hasPattern: 'Tkanina z wzorem',
    ironYN: 'Prasowanie',
    leftOverPercentage: 'Pozostały podział (%)',
    liningCordProduct: 'Sznurek w materiale jako podszewka',
    lockSeamWidth: 'Szerokość zamka (cm)',
    nap: 'Skrzydło',
    noCordProductID: 'Nieznany',
    nonDiverseLinings: 'Standardowa podszewka',
    partsPerHanger: 'Max liczba bryt na wieszak',
    pattern: 'Wzór',
    patternHeight: 'Wysokość wzoru (mm)',
    posCode: 'Kod POS',
    preferredWorkshop: 'Preferowane atelier',
    prices: 'Ceny',
    productType: 'Rodzaj tkaniny',
    purchasePrice: 'Cena zakupu',
    romanBlindCanBeLinedYN: 'Roleta może zawierać podszewkę',
    romanBlindCode: 'Kod rolety',
    romanBlindRibTypeOption: 'Usztywnienia',
    sellingPrice: 'Cena sprzedaży',
    solid: 'Stały',
    sourceLinkDomainProductGroup: 'Preferencje',
    sourceProductGroup: 'Grupa produktowa',
    staggeredPatternYN: 'Rozłożony wzór',
    stockCorrections: 'Korekta zapasu',
    stocks: 'Dostępny stan magazynowy',
    tabDetails: 'Szczegóły',
    tabGeneral: 'Ogólny / ogólne',
    takeOverFromProductGroupToolTip: 'van {productGroupName} ({sourceName})',
    takeOverFromSettingsToolTip: 'van instellingen ({settingsName})',
    washingInstructionProduct: 'Instrukcja prania',
    weightCordProduct: 'Verzwaringskoord',
    weightPerM2InG: 'Waga na m2 (g)',
    width: 'Szerokość (cm)',
    yarn: 'Przędza'
  },
  fabricOrder: {
    actualDeliveryAt: 'Rzeczywista data dostawy',
    createdAt: 'Data utworzenia',
    deliveredQuantity: 'Dostarczono (m)',
    domainName: 'Domena',
    estimatedDeliveryAt: 'Przewidywana data dostarczenia',
    estimatedDepartureAt: 'Przewidywana data wyjazdu',
    externallyModifiedAt: 'Zmodyfikowano dnia',
    fabricOrderStatusOption: 'Status',
    feedbackError: 'Niepowodzenie',
    feedbackOK: 'dobrze',
    feedbackSuccessYN: 'Informacje zwrotne',
    feedbackUndefined: '-',
    orderLines: 'Zamówienia',
    orderNumber: 'Numer zamówienia',
    orderedQuantity: 'Zamówione (m)',
    plannedDeliveryAt: 'Planowany termin dostawy',
    stockLocationName: 'Lokalizacja magazynowa',
    supplierCode: 'Numer dostawcy',
    supplierName: 'Dostawca',
    tabGeneral: 'Ogólny / ogólne',
    totalDeliveredQuantity: 'Razem dostarczone (m)'
  },
  fabricStockReport: {
    availableStock: 'Dostępny zapas',
    blockedStock: 'Zablokowany zapas',
    excelFileName: 'Voorraadoverzicht',
    excelWorksheetName: 'Voorraad',
    includeAvailableAmount: 'Beschikbare voorraad',
    includeBlockedAmount: 'Geblokkeerde voorraad',
    includePositionCode: 'Locatiecode',
    includeReservedAmount: 'Onderhanden werk',
    positionCode: 'Locatiecode',
    reservedStock: 'OHW',
    soldStock: 'Verkocht',
    stockLocations: 'Voorraadlocaties',
    stockReportData: 'Voorraadoverzicht',
    tabGeneral: 'Selectie gegevens',
    totalStock: 'Totaal'
  },
  fileUpload: {
    dragAndDropHtml: 'Zet hier een bestand neer of<br><em>klik hier om een bestand te selecteren</em>',
    uploadTip: 'Upload een bestand tot 2 MB'
  },
  finish: {
    applyPleatMachineCorrectionYN: 'Machine en laser correctie toepassen',
    canBeExcludedDueToFabricYN: 'Stofbeperkingen van toepassing',
    canBeExcludedDueToWorkshopYN: 'Atelierbeperkingen van toepassing',
    extraFabricHeightFormula: 'Formule extra stofhoogte',
    extraFabricWidthFormula: 'Formule extra stofbreedte',
    fabricWidthFactor: 'Stofbreedte factor',
    finishMeasurementFabricFactor: 'Factor op de afwerkingsmaat',
    headingHeight: 'Hoofdhoogte (cm)',
    hideQuantityOnTicket: 'Verberg aantal op bon',
    maximumFabricWidthFactor: 'Bovengrens stofbreedte factor',
    minimumFabricWidthFactor: 'Ondergrens stofbreedte factor',
    parityOption: 'Pariteit',
    quantityFormula: 'Formule voor aantal',
    roundOption: 'Afronding',
    seperateSeriesYN: 'Aparte serie'
  },
  finishType: {
    calculationMethod: 'Rekenwijze',
    extraFabricHeightApplicable: 'Extra stofhoogte van toepassing',
    extraFabricWidthApplicable: 'Extra stofbreedte van toepassing',
    fabricWidthFactorRequired: 'Stofbreedte factor vereist',
    finishes: 'Afwerkingen',
    measurementRequired: 'Afmeting vereist',
    requiredProductType: 'Benodigde artikelsoort'
  },
  forgotPassword: {
    description:
      'U kunt uw wachtwoord opnieuw instellen. Vul het onderstaande formulier in om de instructies per email te ontvangen.',
    done: 'Er is een email verstuurd naar {email}. Volg de instructies die hierin zijn vermeld.',
    submit: 'Verstuur email',
    title: 'Wachtwoord vergeten'
  },
  hemaPendingProject: {
    customerDebtorCode: 'Customer debtor code',
    customerDeliveryCode: 'Customer delivery code',
    customerName: 'Customer name',
    prjDate: 'Project date',
    prjNumber: 'Project number',
    sentDate: 'Sent date'
  },
  home: {
    orderLineStatusSummary: 'STATUSOVERZICHT',
    quickSearch: 'SNEL ZOEKEN',

    welcomeVisitor: 'Welkom bezoeker'
  },
  invalidFinishCombination: {
    finish1: 'Afwerking 1',
    finish2: 'Afwerking 2'
  },
  invoice: {
    clientName: 'Klant',
    details: 'Gedetaileerd',
    exportAccountingAt: 'Verzonden finance',
    exportClientAt: 'Verzonden klant',
    externalInvoice: 'Externe factuur',
    internalInvoice: 'Interne factuur',
    invoiceDate: 'Factuurdatum',
    invoiceNumber: 'Factuurnummer',
    invoicedInternallyYN: 'Intern gefactureerd',
    invoicesPrinted: 'De PDF(s) zijn aangemaakt',
    month: 'Maand',
    numberOfOrders: 'Aantal bonnen',
    print: 'Printen',
    purchaseInvoiceExportedOn: 'IC purchase invoice to Exact',
    salesInvoiceExportedOn: 'IC sales invoice to Exact',
    selectedInvoices: 'Facturen',
    storeCode: 'Vestiging',
    summary: 'Samenvatting',
    totalAmountExcludingVAT: 'Totaalprijs excl. BTW',
    totalAmountIncludingVAT: 'Totaalprijs incl. BTW',
    year: 'Jaar'
  },
  invoiceSummary: {
    create: 'Create invoice summary',
    from: 'From',
    to: 'to'
  },
  language: {
    code: 'ISO 639-1 Code'
  },
  linkPriceListItem: {
    blackoutYN: 'Verduisterd',
    extraCostYN: 'Extra kosten',
    finishesDescription: 'Afwerkingen',
    priceListItem: 'Prijslijstitem',
    priceListItemDescription: 'Prijslijstitembeschrijving',
    selectedFinishes: 'Afwerkingen'
  },
  login: {
    code: 'Gebruikersnaam',
    forbidden: 'Gebruiker/IP combinatie is geblokkeerd.',
    logIn: 'Inloggen',
    password: 'Wachtwoord',
    title: 'Inloggen',
    unauthorised: 'Deze inloggegevens zijn onjuist.'
  },
  mail: {
    bcc: 'Bcc',
    body: 'Bericht',
    cc: 'Cc',
    error: 'Er is een probleem opgetreden. Uw email is niet verstuurd.',
    from: 'Van',
    subject: 'Onderwerp',
    success: 'Uw email is succesvol verzonden',
    to: 'Aan'
  },
  navbar: {
    dashboard: 'Dashboard',
    language: 'Taal',
    logOut: 'Uitloggen',
    screenfull: 'Screenfull',
    size: 'Global Size',
    theme: 'Theme'
  },
  newPassword: {
    description: 'U kunt nu uw wachtwoord permanent wijzigen.',
    done: 'Uw wachtwoord is gewijzigd.',
    invalidToken: 'Deze link is verlopen.',
    submit: 'Wijzig wachtwoord',
    title: 'Nieuw wachtwoord'
  },
  order: {
    clientName: 'Nazwa klienta',
    consumerAddress: 'adres konsumenta',
    consumerDetails: 'Klantgegevens',
    consumerName: 'imię i nazwisko konsumenta',
    createSamples: 'Samples aanmaken',
    createdAt: 'stworzony w',
    finish: 'Afronden',
    internalRemarks: 'Uwagi wewnętrzne',
    orderNumber: 'numer zamówienia',
    orderStatus: 'status zamówienia',
    orderedAt: 'zamówiony od',
    source: 'źródło',
    storeName: 'nazwa sklepu',
    type: 'rodzaj'
  },
  orderLine: {
    actualDeliveryDate: 'Rzeczywista data dostawy',
    alignPatternYN: 'wyrównajWzórYN',
    amount: 'ilość',
    assemblyHeight: 'Wysokość montażu',
    bandMeasurementInCm: 'Band (cm)',
    bottomFinish: 'wykończenie dolne',
    bottomSeam: 'Onderzoom',
    chainProduct: 'łańcuch produktów',
    confirmPrint: 'potwierdź wydruk',
    consumerName: 'imię i nazwisko konsumenta',
    cordProduct: 'Produkt sznurkowy',
    createNewPrice: 'utwórzNowąCenę',
    createReturnOrder: 'createReturnOrder',
    customerReference: 'referencja klienta',
    customerRemarks: 'uwagi klienta',
    cutSize: 'Rozmiar cięcia',
    cutSizeLeft: 'Rozmiar cięcia po lewej (cm)',
    cutSizeRight: 'Rozmiar cięcia po prawej (cm)',
    deliver: 'Dostawa do domu',
    delivery: 'Dostawa',
    deliveryDate: 'data dostawy',
    details: 'Szczegóły',
    discountPercentage: 'Rabat %',
    embraceForOrderNumber: 'Embrassa dla',
    embraceFromFinish: 'Uprzejmy',
    embraceFromOrderLine: 'Embrassa z',
    embraceFromOrderNumber: 'Embrassa z',
    embraceLengthLeft: 'Dłygość - lewa strona (cm)',
    embraceLengthRight: 'Długość - prawa strona (cm)',
    equal: 'Gelijk',
    estimatedDeliveryDate: 'Przewidywana data dostawy',
    exceedance: 'Przekroczenie',
    fabricName: 'Nazwa tkaniny',
    fabricWidth: 'Szerokość tkaniny (cm)',
    familyOrder: 'Rodzina zamówień',
    familyOrderLines: 'Zamówienia',
    finishedWidth: 'Szerokość na gotowo (cm)',
    fixtureFinish: 'Potwierdzenie',
    fromStatus: 'Od statusu',
    generalFinish: 'Podgrupa produktów',
    groupReference: 'Odniesienie grupy',
    groupTotal: 'Suma grupy',
    halfPanelFrom: 'Połowa bryty od',
    halfPanelTo: 'Połowa bryty do',
    headingHeight: 'Główka (cm)',
    height: 'Wysokość na gotowo (cm)',
    highestInSet: 'Highest in set (cm)',
    length: 'Długość (cm)',
    liningFabricProduct: 'Tkanina na podszewkę',
    metersAmountLeft: 'Matery - lewa',
    metersAmountRight: 'Metry - prawa',
    numberOfCords: 'Liczba sznurków',
    numberOfHangers: 'Ilość wieszaków',
    numberOfPanels: 'Liczba bryt',
    numberOfPanelsLeft: 'Ilość bryt - lewa strona',
    numberOfPanelsRight: 'Ilość bryt - prawa strona',
    numberOfParcels: 'Liczba opakowań',
    numberOfSupports: 'Liczba wsporników montażowych',
    operationSide: 'Proces',
    orderDate: 'Data zamówienia',
    orderLinePriceType: 'Typ ceny',
    orderLineStatus: 'Status',
    orderLineSubstatus: 'Substatus',
    orderLinesCancelledLastMonth: 'Zamówienia anulowane od ostatniego miesiąca',
    panelCustomerInfo: 'Informacja od klienta',
    panelFabricInfo: 'Informacje o tkaninie',
    panelFinish: 'Wykończenie',
    panelGeneral: 'Ogólny / ogólne',
    panelLiningFabricInfo: 'Informacje dot. podszewki',
    panelStatus: 'Status',
    parts: 'Delen',
    patternHeight: 'Wysokość wzoru (mm)',
    pickUp: 'odbiór / odebrano',
    pleatFactor: 'Plooifactor',
    priceRestricted: 'Nie można skorygować ceny, ponieważ zamówienie zostało już zafakturowane.',
    printProductionTicket: 'Wydrukuj potwierdzenie zamówienia',
    printStatusOption: 'Status drukowania',
    printStatusOptionFailed: 'Niepowodzenie',
    printStatusOptionPrinted: 'Wydrukowano',
    printStatusOptionQueued: 'W kolejce',
    product: 'Produkt',
    productGroup: 'typ produktu',
    productionTicketPrinted: 'Kwit zamówienia został wysłany do drukarki',
    quantity: 'Ilość',
    railLength: 'Rail length (cm)',
    remarksOnTicket: 'Uwagi',
    ribsEqual: 'Usztywnia to samo',
    ribsSide: 'Ribs position',
    ribsType: 'Usztywnienia',
    ringProduct: 'zasłona z kółkami',
    room: 'Pokój',
    seriesNumber: 'Numer serii',
    shareHalfPanelWith: 'Bryta dzielona z ',
    shareHangerWith: 'Wieszak dzielony z',
    sharesHalfPanel: 'Podziel brytę z zamówieniem …',
    sharesHanger: 'Podziel wieszak z zamówieniem ….',
    status: 'Status',
    storeName: 'Nazwa sklepu',
    systemRemarks: 'Uwagi systemowe ',
    tabGeneral: 'Ogólny / ogólne',
    tabHistory: 'Historia',
    tabPrices: 'Cena',
    takeLeftoverFabric: 'Resztę weź ze sobą',
    ticketNumber: 'Numer zamówienia',
    ticketType: 'Rodzaj fasoli',
    toShipmentList: 'Go to shipment list',
    toStatus: 'Do statusu',
    topFinish: 'Najlepsze wykończenie',
    topFinishHeight: 'Wysokość wykończenia górnego (cm)',
    totalAmount: 'Całkowity',
    totalFabricInCm: 'Całkowita tkanina (cm)',
    transportEAN: 'Numer transportowy',
    unequal: 'Ongelijk',
    urgent: 'Pilne',
    useExistingPrice: 'Użyj istniejącej nagrody',
    validationMessage: 'Informacja o błędzie',
    waveSize: 'Długość fali (cm)',
    weights: 'Loodjes',
    width: 'Szerokość (cm)',
    widthLeft: 'Szerokość lewa (cm)',
    widthRight: 'Szerokość prawa (cm)',
    workshop: 'Atelier'
  },
  orderLineStatus: {
    cancellationAllowed: 'Anuluj',
    changable: 'Z możliwością modyfikacji',
    orderLineStatus: 'Status główny',
    orderLineSubstatus: 'Substatus',
    removeFromSeries: 'Usuń z serii',
    scanParameter: 'Parametr skanowania',
    settable: 'Możliwe do ustawienia',
    substatusOrder: 'Zamówienie',
    substatusOrderReserved: 'Ten numer został zarezerwowany'
  },
  orderLineStatusSummary: {
    fri: 'piątek (pt)',
    mon: 'poniedziałek (pon)',
    sat: 'sobota (sob)',
    sun: 'niedziela (nd)',
    thu: 'zrobić',
    total: 'Całkowity',
    tue: 'di',
    wed: 'Poślubić'
  },
  orderPick: {
    comments: 'uwagi',
    location: 'Lokalizacja',
    neededMeters: 'potrzebna ilość metrów',
    pickListID: 'Numer listy',
    picked: 'Picked',
    pickedMeters: 'przygotowana liczba metrów',
    pickedNumberOfRolls: 'przygotowana liczba rolek',
    prefill: 'Pick needed m',
    processPickedItems: 'Zapisz',
    productCode: 'nr artykułu',
    productDescription: 'opis artykułu',
    selectAPickList: 'wybierz numer listy',
    seriesNumbers: 'Numery serii',
    widthInCm: 'szerokość',
    yarnNumber: 'przędza nr'
  },
  parcelType: {
    alternativeParcelType: 'Alternatieve verpakkingseenheid',
    cuttingPackagesAndRoles: 'pakketten en rollen',
    hangers: 'hangers',
    maximumLengthInM: 'Maximum lengte (m)',
    maximumQuantity: 'Maximum aantal',
    maximumWeightInKg: 'Maximum gewicht (kg)',
    parcelTypeOption: 'Type verpakkingseenheid',
    romanBlindBoxes: 'dozen'
  },
  penalty: {
    handedOutAtUtc: 'Uitgedeeld op (UTC)',
    penaltyPoints: 'Strafpunten',
    penaltyType: 'Type'
  },
  permission: {
    AccessLog: 'Dziennik dostępu',
    AppSetting: 'Ustawienia aplikacji',
    Ban: 'Zakazy',
    Client: 'Klienci',
    Collection: 'Kurz książki',
    Company: 'Firma',
    Configuration: 'Ustawienia',
    Country: 'Kraj',
    Culture: 'Kultura',
    Currency: 'Waluta',
    DeliveryReport: 'Leveringlijst',
    DeliveryTimeReport: 'Rapportage levertijd',
    Domain: 'Domeny',
    DomainUser: 'Domain accounts',
    EventLog: 'Dziennik zdarzeń',
    ExactInstance: 'Exact instances',
    ExternalApiUser: 'Zewnętrzni użytkownicy API',
    ExternalInvoice: 'Faktury',
    Fabric: 'Tkanina',
    FabricOrder: 'Zamówienie na tkaniny',
    FabricReport: 'Fabric details',
    FabricStockReport: 'Przegląd zapasów',
    Finish: 'Wykończenie',
    FinishType: 'Typ wykończenia',
    GLAccount: 'Konta księgi głównej',
    HemaPendingProject: 'HEMA pending projects',
    InvoiceSummary: 'Invoice summaries',
    Language: 'Język',
    LinkDomainDeliveryPrice: 'Ceny dostawy',
    LinkPriceListItem: 'Link do pozycji cennika',
    Option: 'Lista opcji',
    Order: 'Zamówienia',
    OrderLinePrice: 'Cena pozycji w zamówieniu',
    OrderLineStatus: 'Statusy zamówień',
    OrderLineStatusSummary: 'Panel przeglądu stanu',
    OrderPickList: 'Listy do kompletacji zamówień',
    OrderReport: 'Raport zamówień',
    OrderReportVolume: 'Banenlijst',
    ParcelType: 'Jednostki opakowaniowe',
    Permission: 'Uprawnienia',
    PriceListItem: 'Cennik pozycji',
    PriceListItemPrice: 'Cennik cen artykułów',
    PriceListMatrix: 'Macierze cenników',
    PrintTemplate: 'szablony wydruku',
    Printer: 'Drukarka',
    PrinterClient: 'Klienci drukarek',
    Product: 'Artykuł',
    ProductGroup: 'Grupy produktów',
    ProductType: 'Typ produktu',
    ProductionPlanning: 'Utwórz selekcję',
    ProductionPlanningSeries: 'Seria produkcyjna',
    ReasonStockCorrection: 'Przyczyna korekty zapasów',
    ReturnCause: 'Przyczyna zwrotu',
    ReturnReason: 'typ zwrotu',
    ReturnReasonCategory: 'Kategorie dla przyczyny zwrotu',
    Role: 'Rolka',
    Shipment: 'Wysyłka',
    ShipmentListType: 'typy listy wysyłkowej',
    StandardUser: 'Użytkownicy podstawowi',
    Stock: 'Zapas magazynowy',
    StockCorrection: 'Korekta zapasu',
    StockLocation: 'Lokalizacje magazynowe',
    Store: 'Sklep',
    StoreAttribute: 'Charakterystyka lokalizacji',
    StoreFabric: 'Utworzenie listy tkanin',
    StoreType: 'Typ sklepu',
    StoreUser: 'Loginy do sklepów',
    Supplier: 'Dostawca',
    TemplateImage: 'Ikony rachunków',
    Translation: 'Tłumaczenia',
    TransportCompany: 'Przenośniki',
    TransportOrder: 'Lista wysyłkowa',
    TransportRoute: 'Trasy transportowe',
    Truck: 'Pojazdy',
    Unit: 'Jednostki',
    User: 'Użytkownicy',
    VatType: 'Rodzaje podatku VAT',
    Workshop: 'Warsztaty',
    Yarn: 'Przędza',
    execute: 'Wynieść',
    none: 'Nic',
    pageIsReadonly: 'Nie masz uprawnień do zmiany informacji na tej stronie.',
    read: 'Czytaj',
    roles: 'Twoje role',
    selectPlaceholder: 'Wybierz poziom dostępu',
    switchRoles: 'Zmień rolę',
    tabPermissions: 'Uprawnienia',
    tabTaskTypes: 'Typy zadań',
    write: 'Pisać'
  },
  pickrec: {
    chooseEntryFor: 'Selecteer "{caption}"',
    itemNotFound: "'{caption}'",
    suggestionsMayBeMore: 'Er zijn mogelijk meer zoekresulten',
    suggestionsRestCount: 'Er zijn {count} meer zoekresultaten'
  },
  planning: {
    alreadyPlanned: 'Binnen de huidige productieplanning is al een planning gemaakt voor deze productgroep.',
    amount: 'Aantal',
    basedOnOrderDate: 'Op orderdatum',
    capacity: 'Capaciteit',
    capacityRequired: 'Capaciteit is vereisd',
    capacityStep: 'Capaciteit invoeren',
    confirmYear: 'Start production planning for',
    considerStoreAttributes: 'Series op vestigingskenmerk',
    curtainsMeters: 'meters overgordijn',
    curtainsRoomHigh: 'Overgordijnen kamerhoog',
    cuttings: 'Coupage',
    distributionCenterAvailableAmountInMeters: 'Voorraad D.C. (m)',
    domainAvailableAmountInMeters: 'Voorraad totaal (m)',
    estimatedDeliveryDate: 'Verwachte leverdatum',
    excludeDiverseLining: 'Diverse voering uitsluiten',
    excludedFabricsWillBeIgnored: 'Uitgesloten stoffen worden genegeerd (geconfigureerd in het atelier)',
    excludedStores: 'Uitgesloten vestigingen',
    exportSelection: 'Exporteer selecties',
    fabricCode: 'Artikelnummer',
    fabricDescription: 'Stof',
    generate: 'Genereren',
    group: 'Groep',
    inefficientPlanning: 'Je gaat nu inefficiënt plannen',
    installationService: 'Installation service',
    makeCurrent: 'Start planning',
    makeSelection: 'Selectie maken',
    makeSeries: 'Series maken',
    meters: 'Meters',
    netCurtainsMeters: 'meters vitrage',
    netCurtainsRoomHigh: 'Vitrages kamerhoog',
    newProposalWithFilter: 'Nieuw voorstel met filter',
    noStock: 'Geen voorraad',
    oldestOrder: 'Oudste order',
    orderAmount: 'Aantal orders',
    orders: 'Aantal familieorders',
    ordersToPlan: 'Te plannen orders',
    panels: 'Banen',
    pieces: 'Stuks',
    plan: 'Plannen',
    planAgain: 'Nog een keer plannen',
    planningDateRange: 'Deze planning bevat orders tussen de volgende data',
    planningInProgress: 'Er is al een planning bezig in de week van ',
    preselectionMade: "Er is al een selectie bezig voor deze groep. Klik op 'plannen'",
    requiredCapacity: 'Benodigde capaciteit',
    requiredFabric: 'Benodigde stof (m)',
    reset: 'Reset groep',
    romanBlinds: 'Vouwgordijnen',
    selectionStep: 'Selecties maken',
    series: 'Serie',
    seriesNumber: 'Serienummer',
    seriesStep: 'Series maken',
    storeAttribute: 'Vestigingskenmerk',
    tabGeneral: 'Planning capaciteit',
    temporarySave: 'Tijdelijk opslaan',
    tickets: 'Bonnen',
    toPlan: 'Te plannen',
    total: 'Totaal',
    weekNumber: 'Weeknummer',
    workshopAvailableAmountInMeters: 'Voorraad atelier (m)',
    workshopID: 'Atelier',
    workshopOrder: '#',
    yarnDescription: 'Garen'
  },
  planningOption: {
    CurtainRoomHigh: 'Overgordijnen kamerhoog',
    CurtainRoomHighUnit: 'm',
    Cutting: 'Coupage',
    CuttingUnit: 'stuks',
    NetCurtainRoomHigh: 'Vitrages kamerhoog',
    NetCurtainRoomHighUnit: 'meter',
    Panel: 'Banen',
    PanelUnit: 'banen',
    RomanBlind: 'Vouwgordijnen',
    RomanBlindUnit: 'stuks',
    Tieback: 'Embrasses',
    TiebackUnit: 'stuks'
  },
  priceListItem: {
    descriptionInvoice: 'Factuurbeschrijving',
    descriptionInvoiceForeign: 'Factuurbeschrijving internationaal',
    externalOnlyYN: 'Op interne factuur',
    height: 'hoogte',
    intercompany: 'IC',
    laborPrice: 'Maakloon',
    markUpYN: 'Toeslag',
    matrixYN: 'Matrix',
    maximumLength: 'Maximumhoogte',
    maximumWidth: 'Maximumbreedte',
    minimumLength: 'Minimumhoogte',
    minimumWidth: 'Minimumbreedte',
    priceListItems: 'Prijslijstitems',
    productCode: 'Productcode',
    stepSizeLength: 'Stapgrootte hoogte',
    stepSizeWidth: 'Stapgrootte breedte',
    tabCountryMatrix: 'Prijsmatrix ateliers',
    tabGeneral: 'Algemeen',
    tabMatrix: 'Prijsmatrix',
    tabPrices: 'Prijslijst',
    unit: 'Eenheid',
    width: 'Breedte'
  },
  priceListItemPrice: {
    calculatePrices: 'Bereken prijzen',
    consumerPrice: 'Consumentprijs',
    consumerPrices: 'Consumentprijzen',
    currency: 'Valuta',
    laborPrice: 'Maakloon',
    priceType: 'Prijssoort',
    workshopPrices: 'Atelierprijzen'
  },
  printTemplate: {
    domains: 'Domeinen',
    productGroup: 'Productgroep',
    templateDocument: 'Bestandsnaam',
    versionNumber: 'Versie'
  },
  printer: {
    printProvider: 'Provider',
    statusOption: 'Status',
    statusReceivedAt: 'Status ontvangen op',
    statusText: 'Ontvangen status',
    typeOption: 'Printertype'
  },
  product: {
    measurementInMm: 'Maat (mm)',
    ownCode: 'Eigen code',
    ownProduct: 'Eigen product',
    printOnTicket: 'Toon op bon',
    stockItem: 'Voorraadartikel'
  },
  productGroup: {
    active: 'Actief',
    defaultFinishQuantityFormula: 'Standaard formule voor aantal (uit afwerking)',
    description: 'Beschrijving',
    finishTypes: 'Afwerkingssoorten',
    maximumFabricWidthInCm: 'Maximum stofbreedte ongevoerd (cm)',
    maximumHeightInCm: 'Maximum hoogte ongevoerd (cm)',
    maximumLinedFabricWidthInCm: 'Maximum stofbreedte gevoerd (cm)',
    maximumLinedHeightInCm: 'Maximum hoogte gevoerd (cm)',
    maximumLinedWidthInCm: 'Maximum breedte gevoerd (cm)',
    maximumNumberOfLinedPanels: 'Maximum aantal banen gevoerd',
    maximumNumberOfPanels: 'Maximum aantal banen ongevoerd',
    maximumWidthInCm: 'Maximum breedte ongevoerd (cm)',
    minimumHeightInCm: 'Minimum hoogte (cm)',
    minimumNumberOfPanels: 'Minimaal aantal banen',
    minimumWidthInCm: 'Minimum breedte (cm)',
    parcelType: 'Verpakkingseenheid',
    productGroupDescription: 'Beschrijving',
    productGroupTypeOption: 'Berekeningen volgens',
    productGroups: 'Productgroepen',
    shipmentListType: 'Type verzendlijst',
    tabPossibleFabricProductTypes: 'Mogelijke stoffen',
    tabPossibleFinishes: 'Mogelijke afwerkingen'
  },
  productType: {
    fabricTypeOption: 'Stofsoort',
    measurementRequiredYN: 'Maat verplicht',
    products: 'Artikelen',
    velours: 'Velours'
  },
  reasonStockCorrection: {
    reasonStockCorrectionOption: 'Categorie'
  },
  report: {
    deliveryReport: 'Leveringlijst',
    export: 'Exporteer lijst',
    orderReport: 'Banenlijst'
  },
  request: {
    networkError: 'Het netwerk is op dit moment niet bereikbaar.'
  },
  return: {
    return: 'Retour',
    returnCause: 'Retouroorzaak',
    returnPriceListItem: 'Te koppelen prijs',
    returnReason: 'Retourreden',
    returnReasonCategory: 'Retourredencategorie',
    returnReasonCategoryCode: 'Rapportage nummer',
    returnReasonCharacter: 'Rapportage letter',
    returnReasons: 'Retourredenen',
    returnType: 'Retourtype'
  },
  route: {
    Table: 'Table',
    avatarUpload: 'Avatar Upload',
    clipboardDemo: 'Clipboard',
    complexTable: 'Complex Table',
    componentIndex: 'Introduction',
    componentMixin: 'Mixin',
    components: 'Components',
    countTo: 'CountTo',
    createClient: 'Klant aanmaken',
    createCollection: 'Stofboek aanmaken',
    createCompany: 'Bedrijf aanmaken',
    createContactPerson: 'Contactpersoon aanmaken',
    createCountry: 'Land aanmaken',
    createCulture: 'Culture aanmaken',
    createCurrency: 'Valuta aanmaken',
    createDomain: 'Domein aanmaken',
    createExactInstance: 'Create Exact instance',
    createExternalApiUser: 'Externe API gebruiker aanmaken',
    createFabric: 'Stof aanmaken',
    createFabricOrder: 'Stoforder aanmaken',
    createFabricOrderLine: 'Stoforderregel aanmaken',
    createFinish: 'Afwerking aanmaken',
    createFinishType: 'Afwerkingssoort aanmaken',
    createInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie aanmaken',
    createLanguage: 'Taal aanmaken',
    createLinkDomainDeliveryPrice: 'Bezorgprijs aanmaken',
    createLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    createLinkDomainProductGroupFinish: 'Domeinspecifieke afwerking aanmaken',
    createLinkPriceListItem: 'Koppeling prijslijstitem aanmaken',
    createLinkStoreCollection: 'Stofboek toekennen',
    createOrder: 'Order aanmaken',
    createOrderLine: 'Order aanmaken',
    createOrderLinePrice: 'Orderregelprijs aanmaken',
    createOrderLineStatus: 'Order status aanmaken',
    createParcelType: 'Verpakkingseenheid aanmaken',
    createPriceListItem: 'Prijslijstitem aanmaken',
    createPriceListItemPrice: 'Prijslijstitem prijs aanmaken',
    createPriceListMatrix: 'Prijslijstmatrix aanmaken',
    createPrintTemplate: 'Template aanmaken',
    createPrinter: 'Printer aanmaken',
    createPrinterClient: 'Printer client aanmaken',
    createProduct: 'Artikel aanmaken',
    createProductGroup: 'Productgroep aanmaken',
    createProductType: 'Artikelsoort aanmaken',
    createProductionPlanning: 'Selectie aanmaken',
    createReasonStockCorrection: 'Reden voorraadcorrectie aanmaken',
    createReturnCause: 'Retouroorzaak aanmaken',
    createReturnReason: 'Retourreden aanmaken',
    createReturnReasonCategory: 'Retourredencategorie aanmaken',
    createRole: 'Rol aanmaken',
    createShipmentListType: 'Type verzendlijst aanmaken',
    createStandardUser: 'Gebruiker aanmaken',
    createStock: 'Voorraad aanmaken',
    createStockLocation: 'Voorraadlocatie aanmaken',
    createStore: 'Vestiging aanmaken',
    createStoreAttribute: 'Kenmerk aanmaken',
    createStoreType: 'Vestigingstype aanmaken',
    createSupplier: 'Leverancier aanmaken',
    createTemplateImage: 'Bonpictogram aanmaken',
    createTransportCompany: 'Transporteur aanmaken',
    createTransportRoute: 'Transportroute aanmaken',
    createTruck: 'Voertuig aanmaken',
    createUnit: 'Eenheid aanmaken',
    createUrgentSeries: 'Spoedserie aanmaken',
    createUser: 'Gebruiker aanmaken',
    createVatType: 'BTW-soort aanmaken',
    createVatTypeRate: 'BTW-tarief aanmaken',
    createWorkshop: 'Atelier aanmaken',
    createYarn: 'Garen aanmaken',
    createglAccount: 'Grootboekrekeningnummer aanmaken',
    customTreeTable: 'Custom TreeTable',
    dashboard: 'Dashboard',
    directivePermission: 'Directive Permission',
    documentation: 'Documentation',
    dragDialog: 'Drag Dialog',
    dragTable: 'Drag Table',
    dropzone: 'Dropzone',
    dynamicTable: 'Dynamic Table',
    editClient: 'Klant bewerken',
    editCollection: 'Stofboek bewerken',
    editCompany: 'Bedrijf bewerken',
    editConfiguration: 'Instelling bewerken',
    editContactPerson: 'Bewerk contactpersoon',
    editCountry: 'Land bewerken',
    editCulture: 'Culture bewerken',
    editCurrency: 'Valuta bewerken',
    editDomain: 'Domein bewerken',
    editExactInstance: 'Edit Exact instance',
    editExternalApiUser: 'Externe API gebruiker bewerken',
    editFabric: 'Stof bewerken',
    editFabricOrder: 'Bewerk stoforder',
    editFabricOrderLine: 'Stoforderregel bewerken',
    editFinish: 'Afwerking bewerken',
    editFinishType: 'Afwerkingssoort bewerken',
    editInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie bewerken',
    editLanguage: 'Taal bewerken',
    editLinkDomainDeliveryPrice: 'Bezorgprijs bewerken',
    editLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    editLinkDomainProductGroupFinish: 'Bewerk domeinspecifieke afwerking',
    editLinkPriceListItem: 'Koppeling prijslijstitem bewerken',
    editLinkStoreCollection: 'Stofboek toekennen',
    editOrder: 'Order bewerken',
    editOrderLine: 'Order bewerken',
    editOrderLinePrice: 'Orderregelprijs bewerken',
    editOrderLineStatus: 'Order status bewerken',
    editOrderPickList: 'Edytuj listę wyboru',
    editParcelType: 'Verpakkingseenheid bewerken',
    editPriceListItem: 'Prijslijstitem bewerken',
    editPriceListItemPrice: 'Prijslijstitem prijs bewerken',
    editPriceListMatrix: 'Prijslijstmatrix bewerken',
    editPrintTemplate: 'Template bewerken',
    editPrinter: 'Printer bewerken',
    editPrinterClient: 'Printer client bewerken',
    editProduct: 'Artikel bewerken',
    editProductGroup: 'Productgroep bewerken',
    editProductType: 'Artikelsoort bewerken',
    editProductionPlanning: 'Selectie bewerken',
    editReasonStockCorrection: 'Reden voorraadcorrectie bewerken',
    editReturnCause: 'Retouroorzaak bewerken',
    editReturnReason: 'Retourreden bewerken',
    editReturnReasonCategory: 'Retourredencategorie bewerken',
    editRole: 'Rol bewerken',
    editShipmentListType: 'Type verzendlijst bewerken',
    editStandardUser: 'Edit user',
    editStock: 'Voorraad bewerken',
    editStockLocation: 'Voorraadlocatie bewerken',
    editStore: 'Vestiging bewerken',
    editStoreAttribute: 'Kenmerk bewerken',
    editStoreType: 'Vestigingstype bewerken',
    editStoreUser: 'Gebruiker bewerken',
    editSupplier: 'Leverancier bewerken',
    editTemplateImage: 'Bewerk bonpictogram',
    editTranslation: 'Vertaling bewerken',
    editTransportCompany: 'Transporteur bewerken',
    editTransportOrder: 'Verzendlijst bewerken',
    editTransportRoute: 'Transportroute bewerken',
    editTruck: 'Voertuig bewerken',
    editUnit: 'Eenheid bewerken',
    editUser: 'Gebruiker bewerken',
    editVatType: 'BTW-soort bewerken',
    editVatTypeRate: 'BTW-tarief bewerken',
    editWorkshop: 'Atelier bewerken',
    editYarn: 'Garen bewerken',
    editglAccount: 'Grootboekrekeningnummer bewerken',
    errorLog: 'Error Log',
    errorPages: 'Error Pages',
    example: 'Example',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    exportZip: 'Export Zip',
    externalLink: 'External Link',
    form: 'Form',
    guide: 'Guide',
    home: 'Home',
    i18n: 'I18n',
    icons: 'Icons',
    inlineEditTable: 'Inline Edit',
    introduction: 'Introduction',
    jsonEditor: 'JSON Editor',
    markdown: 'Markdown',
    menu_admin: 'Zarządzanie',
    menu_admin_accesslog: 'Dziennik dostępu',
    menu_admin_application: 'Podanie',
    menu_admin_appsettings: 'Ustawienia aplikacji',
    menu_admin_bans: 'zakazy',
    menu_admin_collections: 'Książki o kurzu',
    menu_admin_company_structure: 'Struktura firmy',
    menu_admin_configuration: 'Ustawienia',
    menu_admin_countries: 'Narody',
    menu_admin_eventlog: 'Dziennik zdarzeń',
    menu_admin_exact_instances: 'Exact instances',
    menu_admin_external_api_users: 'Logowanie do zewnętrznego interfejsu API',
    menu_admin_fabric_order: 'Zamówienia tkanin',
    menu_admin_fabrics: 'lista tkanin',
    menu_admin_finishtypes: 'Wykończenia',
    menu_admin_invoicing: 'Dane do faktury',
    menu_admin_languages: 'Języki',
    menu_admin_masterdata: 'Podstawowe dane',
    menu_admin_options: 'Listy wyboru',
    menu_admin_ordering_api_users: 'Zamów loginy API',
    menu_admin_penalties: 'Kary',
    menu_admin_pricing: 'Ceny',
    menu_admin_printtemplates: 'Zamów szablony kuponów',
    menu_admin_productgroups: 'Grupy produktów',
    menu_admin_production: 'produkcja',
    menu_admin_products: 'artykuły',
    menu_admin_producttypes: 'artykuły',
    menu_admin_reasonstockcorrections: 'Powody korekt stanów magazynowych',
    menu_admin_roles: 'Rolka',
    menu_admin_store_users: 'Sklepy',
    menu_admin_templateimages: 'ikony paragonów',
    menu_admin_translations: 'Tłumaczenia',
    menu_admin_transport: 'Transport',
    menu_admin_units: 'Jednostki',
    menu_admin_users: 'Użytkownicy',
    menu_admin_vattypes: 'Rodzaje VAT',
    menu_admin_yarns: 'Przędza',
    menu_client_management: 'Zarządzanie klientami',
    menu_client_sales_report: 'Omzetlijst',
    menu_clients: 'Klienci',
    menu_companies: 'Biznes',
    menu_component_list: 'Lista komponentów',
    menu_cultures: 'Kultury',
    menu_currencies: 'Waluty',
    menu_delivery_report: 'Leveringlijst',
    menu_domains: 'Domeny',
    menu_external_invoices: 'Faktury zewnętrzne ',
    menu_fabric_management: 'Tekstylia',
    menu_fabric_report: 'Fabric details',
    menu_fabric_stockcorrections: 'Korekta zapasów',
    menu_fabric_stockreport: 'Przegląd zapasów',
    menu_hema: 'HEMA',
    menu_internal_invoices: 'Faktury wewnętrzne',
    menu_invoice_summary: 'Podsumowanie faktury',
    menu_invoicing: 'Dane do faktury',
    menu_link_domain_delivery_prices: 'Ceny dostawy',
    menu_link_price_list_items: 'Link do pozycji cennika',
    menu_order_handling: 'Zamówienia',
    menu_order_line_prices: 'Ceny linii zamówienia',
    menu_order_line_statuses: 'Statusy zamówień',
    menu_order_pick_list: 'Utwórz listę kompletacji zamówień',
    menu_order_pick_list_complete: 'Wysłano listę kompletacji zamówień',
    menu_order_report: 'lista datacom',
    menu_order_report_volume: 'Banenlijst',
    menu_orderlines: 'Zamówienia',
    menu_orders: 'Lista zamówień',
    menu_parcel_types: 'Jednostki opakowaniowe',
    menu_planning: 'Harmonogram',
    menu_price_list_item_prices: 'Cennik cen pozycji',
    menu_price_list_items: 'Pozycje cennika',
    menu_price_list_matrices: 'Macierze cennika',
    menu_printer_clients: 'Klienci drukarki',
    menu_production_planning: 'Wybieranie',
    menu_reports: 'Raport',
    menu_return_causes: 'Przyczyny zwrotu',
    menu_return_type_categories: 'Powody zwrotu',
    menu_return_types: 'Typy zwrotu',
    menu_series: 'Seria',
    menu_shipment_list_types: 'Rodzaje list wysyłkowych',
    menu_show_orders: 'Show samples',
    menu_status_list: 'Lista statusu',
    menu_store: 'Ustanowienie',
    menu_store_fabrics: 'Tekstylia',
    menu_store_orders: 'Zamówienia',
    menu_stores: 'Lokalizacje',
    menu_suppliers: 'Dostawcy',
    menu_transport: 'Transport',
    menu_transport_companies: 'Przewoźnicy',
    menu_transport_list: 'Listy mailingowe',
    menu_transport_planning: 'Twórz listy mailingowe',
    menu_transport_routes: 'Trasy transportowe',
    menu_trucks: 'Pojazdy',
    menu_workshops: 'Warsztaty',
    page401: '401',
    page403: '403',
    page404: '404',
    pagePermission: 'Page Permission',
    permission: 'Permission',
    selectExcel: 'Export Selected',
    splitPane: 'SplitPane',
    sticky: 'Sticky',
    tab: 'Tab',
    theme: 'Theme',
    tinymce: 'Tinymce',
    treeTable: 'Tree Table',
    uploadExcel: 'Upload Excel',
    userSettings: 'Instellingen gebruiker',
    zip: 'Zip'
  },
  series: {
    addOrderNumbers: 'Dodaj numery zamówień',
    amount: 'Ilość',
    amountOfEmbraces: 'Liczba embrass',
    amountOfHangers: 'Wieszaki',
    amountOfOrderLines: 'Zamówienia',
    amountOfOrders: 'Rodzina zamówień',
    amountOfParcels: 'Opakowanie',
    amountOfRings: 'ilość kółek',
    amountOfWaves: 'Fale fałdowe',
    bulkActionLabel: 'zmień wybór zamówień',
    confirmDelete: 'Czy na pewno chcesz usunąć wybrane zamówienia z serii?',
    confirmPrint: 'Czy na pewno chcesz wydrukować wybrane bony?',
    confirmUpdate: 'Czy na pewno chcesz zaktualizować wybrane zamówienia?',
    domainName: 'Domena',
    doubleOrderNumber: 'Podwójny numer zamówienia',
    numberOfMeters: 'Liczba metrów',
    numberOfPanels: 'Liczba bryt',
    orderNumbersAdded: 'Dodano numery zamówień',
    orderNumbersNotAdded: 'Nie można dodać numerów zamówień',
    pieces: 'Szt',
    printTickets: 'wydrukuj zamówienia',
    quantity: 'Ilość',
    series: 'Seria',
    seriesDescription: 'Seria',
    seriesNumber: 'Numer serii',
    seriesPrintError: 'nie wszystkie zamówienia udało się wydrukować',
    seriesPrintStart: 'Bony są drukowane',
    seriesPrintSuccess: 'Potwierdzenia zostały wysłane do {printDestination}',
    seriesStatus: 'Status',
    ticketsAlreadyPrintedCancel: 'Tak, przedrukuj wszystko',
    ticketsAlreadyPrintedConfirm: 'nie, jedynie nowe zamówienia',
    ticketsAlreadyPrintedMessage: 'Bony zostały wydrukowane, czy chcesz uruchomić ponowny wydruk?',

    ticketsAlreadyPrintedTitle: 'Ostrzeżenie',
    typeOfOrders: 'Rodzaje zamówień',
    unit: 'Jednostka',
    updateOrderLines: 'Aktualizuję',
    weekNumber: 'Tydzień',
    workshopName: 'Atelier'
  },
  size: {
    medium: 'Normaal',
    mini: 'Kleinst',
    small: 'Klein'
  },
  statusList: {
    allOrders: 'Wszystkie zamówienia',
    fabricCode: 'Numer artykułu',
    fabricName: 'Nazwa tkaniny',
    hangers: 'Wieszaki',
    notScanned: 'Niezeskanowane',
    scanned: 'Zeskanowane',
    seriesNumber: 'Numer serii',
    seriesPlaceholder: 'Numery serii [1-5,7,10-12]',
    status: 'Status',
    storeCode: 'Numer sklepu',
    storeName: 'Nazwa sklepu',
    subStatus: 'Substatus',
    ticketNumber: 'Numer zamówienia'
  },
  stock: {
    mutatedAt: 'Data rezerwacji',
    mutationInMeters: 'Liczba metrów',
    mutationReason: 'Przyczyna',
    onlyShowFabricsWithAvailableStock: 'Pokaż tylko tkaniny z dostępnym stanem magazynowym',
    positionCode: 'Kod lokalizacji',
    stockAvailable: 'Dostępny stan magazynowy (m)',
    stockBlocked: 'Zablokowany zapas (m)',
    stockLocationName: 'Lokalizacja magazynowa',
    stockReserved: 'Produkcja w toku (m)',
    stockSold: 'Verkochte voorraad (m)'
  },
  stockCorrection: {
    availableAmount: 'Dostępny stan magazynowy (m)',
    chooseReasonStockCorrection: 'Powód korekty zapasów',
    clearInput: 'Usuń dane wejściowe',
    clearInputSuggestion: 'Przetwórz lub usuń swoje wpisy, aby zmienić listy zapasów',
    clearInputWarning: 'Wszystkie Twoje wpisy zostaną usunięte',
    correction: 'Korekta (m)',
    createdAt: 'Data rezerwacji',
    mutation: 'Rezerwacja tkaniny (m)',
    processStockCorrection: 'Przetwarzaj korekty zapasów',
    reason: 'Przyczyna',
    reasonRequired: 'Wymagane podanie przyczyny',
    remarks: 'Uwaga',
    saveSelection: 'Zapisz korektę',
    selectAStockLocation: 'Wybierz lokalizację magazynu',
    stockLocationName: 'Lokalizacja magazynowa',
    stockProductCode: 'Numer artykułu',
    stockProductDescription: 'Tkanina'
  },
  store: {
    attribute: 'Kenmerk',
    code: 'Vestigingsnummer',
    collection: 'Stofboek',
    domain: 'Domein',
    height: 'Hoogte (cm)',
    name: 'Vestigingsnaam',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabSettings: 'Instellingen',
    tabStoreCollections: 'Stofboeken',
    type: 'Type'
  },
  storeFabric: {
    availableStockInM: 'Zapas magazynowy (m)',
    estimatedNewStock: 'Oczekiwany nowy stan magazynowy',
    soldStockInM: 'Sprzedane (m)'
  },
  storeUser: {
    clientName: 'Klient',
    storeCode: 'Numer sklepu',
    storeName: 'Sklep'
  },
  supplier: {
    agentName: 'Naam agent',
    code: 'Leveranciersnummer',
    domain: 'Domein',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen'
  },
  table: {
    actions: 'Acties',
    searchDatePlaceholder: 'Typ of selecteer',
    searchPlaceholder: 'Typ om te zoeken',
    searchSelectPlaceholder: 'Selecteer om te zoeken',
    withRestriction: 'Met beperking'
  },
  tagsView: {
    close: 'Sluiten',
    closeAll: 'Alle sluiten',
    closeOthers: 'Andere sluiten',
    refresh: 'Verversen'
  },
  templateImage: {
    templateDocument: 'Afbeelding (png)',
    templateImageTypeOption: 'Type pictogram'
  },
  translation: {
    code: 'Vertalingcode'
  },
  transport: {
    loadingAddress: 'Laadadres',
    loadingAddressCode: 'Code laadadres',
    loadingTimeRange: 'Laadtijden (van, tot)',
    shipperNumber: 'Verladernummer winkelbezorging',
    shipperNumberHomeDelivery: 'Verladernummer thuisbezorging',
    transportCompany: 'Transporteur',
    unloadingAddressCode: 'Code losadres',
    unloadingTimeRange: 'Lostijden (van, tot)'
  },
  transportOrder: {
    confirmAlreadyExportedExport: 'Ta lista mailingowa została już wysłana. Czy chcesz go ponownie wysłać?',
    confirmExport: 'Czy chcesz wysłać tę listę wysyłkową do firmy transportowej?',
    countryCode: 'Kraj',
    createShipments: 'Utwórz listę wysyłkową',
    domainOrderNumberPrefix: 'Domena',
    exportShipments: 'Wysyłać',
    exportedAt: 'Lista wysyłkowa została wysłana',
    exportedTo: 'Naar',
    fromDate: 'Zamówienia od',
    hangers: 'Wieszaki',
    isExcluded: 'Nie zostanie wysłany',
    isIncluded: 'Wysyłam',
    parcels: 'Wieszaki / opakowanie',
    planningDateRange: 'Ta lista zawiera zamówienia zeskanowane między następującymi datami',
    reference: 'Referencyjny',
    scannedAt: 'Zeskanowano o',
    seriesNumber: 'Numer serii',
    shipmentAt: 'Czas transportu',
    shipmentListTypeName: 'typ listy wysyłkowej',
    shipments: 'Wysyłki',
    shipmentsCreated: 'Utworzono listy mailingowe',
    shipmentsExportError: 'Nie można wysłać listy mailingowej do firmy przewozowej',
    shipmentsExported: 'Lista mailingowa została wysłana do firmy przewozowej',
    status: 'Status',
    storeAttribute: 'Odniesienie do lokalizacji',
    storeCode: 'Numer sklepu',
    subStatus: 'Substatus',
    ticketNumber: 'Numer zamówienia',
    truckIdentifier: 'Pojazd',
    untilDate: 'Zamówienia do',
    workshops: 'Atelier(s)'
  },
  transportRoute: {
    code: 'Routecode',
    countryCode: 'Land',
    postalCodeFrom: 'Postcode van',
    postalCodeTo: 'Postcode tot'
  },
  unit: {
    meters: 'metry',
    panels: 'bryty',
    pieces: 'szt'
  },
  user: {
    avatar: 'Zdjęcie profilowe',
    avatarInfo: 'URL do zdjęcia profilowego',
    newPassword: 'Nowe hasło',
    newPasswordInfo: 'Pozostaw puste, jeśli nie chcesz zmieniać hasła',
    oldPassword: 'Aktualne hasło',
    oldPasswordInfo: 'Wprowadź hasło',
    oldPasswordInvalid: 'Nie wprowadziłeś prawidłowego aktualnego hasła',
    passwordChanged: 'Twoje hasło zostało zmienione',
    repeatPassword: 'Powtórz hasło',
    repeatPasswordInfo: 'Powtórz nowe hasło',
    roles: 'Rolka',
    workingAt: 'Pracuje w'
  },
  validation: {
    cannotExcludePreferredWorkshop: 'Het voorkeursatelier kan niet worden uitgesloten',
    complexity: 'Kies complexiteit',
    ean: 'Deze barcode is incorrect',
    email: 'Dit is een ongeldig e-mailadres',
    error: {
      alphanumeric: 'Minstens 1 symbool is vereist',
      digit: 'Minstens 1 getal is vereist',
      invalidFormula: 'Eén of meerdere formules bevat een fout: {errorMessage}',
      isFromDatabase: 'Het wachtwoord kan niet worden gevalideerd, omdat de server niet bereikbaar is.',
      itemNotFound: 'Bestand is reeds verwijderd.',
      length: 'Minstens {count} karakters zijn vereist',
      lowercase: 'Minstens 1 kleine letter is vereist',
      passwordComplexity: 'Het wachtwoord voldoet niet aan de vereiste complexiteit',
      uppercase: 'Minstens 1 hoofdletter is vereist'
    },
    formValidationFailed: 'Dit formulier bevat fouten. Controleer uw invoer en probeer het opnieuw',
    notAllWorkshopsCanBeExcluded: 'Er moet tenminste 1 atelier beschikbaar zijn',
    numeric: 'Alleen cijfers toegestaan',
    oldPasswordRequired: 'Vul het oude wachtwoord in',
    repeatPasswordMismatch: 'Twee wachtwoorden komen niet overeen',
    required: 'Dit veld is vereist'
  },
  vat: {
    countryCode: 'Land',
    countryID: 'Land',
    glCodePurchase: 'Btw-code inkoop',
    glCodeSales: 'Btw-code verkoop',
    invoiceText: 'Tekst op factuur',
    rates: 'Tarieven',
    startDate: 'Ingangsdatum',
    taxCategoryCode: 'UNECE code',
    vatNumber: 'BTW-nummer',
    vatNumberRequiredYN: 'BTW-nummer verplicht',
    vatPercentage: 'Tarief (%)',
    vatType: 'BTW-soort',
    vatTypeOption: 'Type'
  },
  wizard: {
    next: 'Następna',
    prev: 'Poprzedni',
    skip: 'Ominąć',
    skipnexttwo: 'Pomiń (2)'
  },
  workshop: {
    code: 'Workshop number',
    excludeExpressOrderYN: 'Uitsluiten van spoedorders',
    excludeHandlockYN: 'Uitsluiten van handlock',
    excludeSamplesYN: ' Uitsluiten van showbanen',
    ignoreExcludedFabrics: 'Ignore excluded fabrics',
    maximumProcessingHeight: 'Maximale verwerkingshoogte (cm)',
    metersMaxPerSeries: 'Meters per serie',
    panelsMaxPerSeries: 'Banen per serie',
    romanBlindsMaxPerSeries: 'Vouwgordijnen per serie',
    stockLocationName: 'Naam voorraadlocatie'
  },
  yarn: {
    planningOrder: 'Planningsvolgorde'
  }
};
